import React from 'react';

const Terms: React.FC = () => {
    return (
        <section className="hero-section terms-section text-center text-white">
          <h1 className="hero-headline">Terms & Conditions</h1>
          <div className="hero-paragraph text-start mx-auto" style={{ maxWidth: '700px' }}>
            <p>Sorry, we are a startup and cannot hold any financial risk. If you have any questions about the tool, business logic, hosting, SLA or anything, please reach out. Below you find our strict T&C:</p>
            <p>
              VoyCalc is provided as a tool to assist in voyage estimation and related calculations. While we strive to ensure the accuracy and reliability of the results, all outputs generated by VoyCalc are to be treated as indicative only.
            </p>
            <p>
              Under no circumstances shall VoyCalc, its developers, or affiliated parties be held liable for any decisions made, actions taken, or losses incurred based on the results provided by this platform.
            </p>
            <p>
              Users are solely responsible for verifying and validating all calculations before relying on them in any operational, financial, or commercial context. We do not guarantee the completeness, accuracy, or suitability of any output for a particular purpose.
            </p>
            <p>
              By using VoyCalc, you acknowledge and accept that it is your responsibility to independently evaluate the results and assumptions. Use of this tool is at your own risk.
            </p>
          </div>
        </section>
    );
}

export default Terms